import BetterScroll from 'better-scroll';
import MouseWheel from '@better-scroll/mouse-wheel';
import Slide from '@better-scroll/slide';
import Wheel from '@better-scroll/wheel';
export function createSliderProvider(dotNetSliderProvider) {
    return new SliderProvider(dotNetSliderProvider);
}
class SliderProvider {
    constructor(dotNetSliderProvider) {
        this.dotNetSliderProvider = dotNetSliderProvider;
    }
    initialize(slideElementId) {
        BetterScroll.use(MouseWheel);
        BetterScroll.use(Wheel);
        BetterScroll.use(Slide);
        this.createScrollInstance(slideElementId);
    }
    refresh() {
        this.slideInstance.refresh();
    }
    getCurrentSliderIndex() {
        return this.slideInstance.getCurrentPage().pageX;
    }
    createScrollInstance(slideElementId) {
        const scrollElement = document.getElementById(slideElementId);
        this.slideInstance = new BetterScroll(scrollElement, {
            scrollX: true,
            scrollY: false,
            slide: {
                loop: true,
                threshold: 0.5,
                speed: 400,
                listenFlick: true,
                autoplay: true,
                interval: 3000,
            },
            momentum: false,
            bounce: false,
            probeType: 3,
            click: true
        });
    }
}
